export const HERMES_EXECUTIVE_AGENT_ID = "tradvera.hermes.executive.v1" as const;
export const HERMES_SPECIALIST_AGENT_IDS = [
  "tradvera.hermes.opportunity-center.v1",
  "tradvera.hermes.company-evaluation.v1",
  "tradvera.hermes.decision-room.v1",
] as const;
export type HermesSpecialistAgentIdV1 = typeof HERMES_SPECIALIST_AGENT_IDS[number];

export type HermesSpecialistReportingBoundaryV1 = {
  reportsToAgentId: typeof HERMES_EXECUTIVE_AGENT_ID;
  channel: "SIGNED_RESULT_ENVELOPE_ONLY";
  directPhoneDelivery: false;
};

export type HermesSpecialistResultEnvelopeV1 = {
  schemaVersion: "tradvera.hermes-specialist-result-envelope.v1";
  reportId: string;
  sourceAgentId: HermesSpecialistAgentIdV1;
  domain: "OPPORTUNITY_CENTER" | "COMPANY_EVALUATION" | "DECISION_ROOM";
  sourceBinding: {
    sourceType: "OPPORTUNITY_RUN" | "COMPANY_EVALUATION_RUN" | "DECISION_ROOM_REVISION";
    sourceId: string;
    sourceHashSha256: string;
    snapshotId: string | null;
  };
  createdAt: string;
  priority: "ROUTINE" | "WATCH" | "MATERIAL" | "URGENT_REVIEW";
  headlineAr: string;
  summaryAr: string;
  reasonCodes: string[];
  evidenceIds: string[];
  deduplicationKey: string;
  validUntil: string;
  reportsToAgentId: typeof HERMES_EXECUTIVE_AGENT_ID;
  directPhoneDelivery: false;
  mutationAuthority: false;
  executionAuthority: false;
};

export type HermesExecutiveDelegationCommandV1 = {
  schemaVersion: "tradvera.hermes-executive-delegation-command.v1";
  commandId: string;
  issuedByAgentId: typeof HERMES_EXECUTIVE_AGENT_ID;
  targetAgentId: HermesSpecialistAgentIdV1;
  sourceChannel: "OWNER_PHONE_CHAT";
  ownerIntent:
    | "EVALUATE_COMPANY"
    | "REFRESH_OPPORTUNITIES"
    | "READ_DECISION_ROOM"
    | "MONITOR_DECISION"
    | "DISMISS_DECISION"
    | "REPORT_PURCHASE";
  parameters: { symbol: string | null; reasonAr: string | null };
  issuedAt: string;
  idempotencyKey: string;
  explicitOwnerCommand: true;
  mutationConfirmationRequired: boolean;
  executionAuthority: false;
};

export const HERMES_AGENT_TOPOLOGY_V1 = {
  schemaVersion: "tradvera.hermes-agent-topology.v1",
  executive: {
    agentId: HERMES_EXECUTIVE_AGENT_ID,
    role: "PROJECT_EXECUTIVE_AND_SINGLE_PHONE_VOICE",
    acceptsOnlySignedSpecialistResults: true,
    routesExplicitOwnerPhoneCommands: true,
    deduplicatesAndPrioritizes: true,
    phoneDeliveryAuthority: true,
    calculationAuthority: false,
    executionAuthority: false,
  },
  specialists: [
    { agentId: HERMES_SPECIALIST_AGENT_IDS[0], domain: "OPPORTUNITY_CENTER", role: "DISCOVERY_RANKING_AND_READINESS_MONITOR", reportsToAgentId: HERMES_EXECUTIVE_AGENT_ID, directPhoneDelivery: false, executionAuthority: false },
    { agentId: HERMES_SPECIALIST_AGENT_IDS[1], domain: "COMPANY_EVALUATION", role: "FIVE_ROOM_ORCHESTRATOR", reportsToAgentId: HERMES_EXECUTIVE_AGENT_ID, directPhoneDelivery: false, executionAuthority: false },
    { agentId: HERMES_SPECIALIST_AGENT_IDS[2], domain: "DECISION_ROOM", role: "DECISION_LIFECYCLE_AND_TRIGGER_MONITOR", reportsToAgentId: HERMES_EXECUTIVE_AGENT_ID, directPhoneDelivery: false, executionAuthority: false },
  ],
} as const;
